import { apiService as api } from './api.service';

export const messagingApi = {
  // Provider Types
  getProviderTypes: () => api.get('/messaging-provider-types'),
  getProviderType: (id: string) => api.get(`/messaging-provider-types/${id}`),

  // Providers
  createProvider: (data: any) => api.post('/messaging-providers', data),
  getProviders: (tenantId?: string) =>
    api.get(tenantId ? `/messaging-providers?tenantId=${tenantId}` : '/messaging-providers'),
  getProvider: (id: string) => api.get(`/messaging-providers/${id}`),
  updateProvider: (id: string, data: any) =>
    api.patch(`/messaging-providers/${id}`, data),
  deleteProvider: (id: string) => api.delete(`/messaging-providers/${id}`),
  getDefaultProvider: (tenantId: string) =>
    api.get(`/messaging-providers/default/${tenantId}`),

  // Templates
  createTemplate: (data: any) => api.post('/message-templates', data),
  getTemplates: (tenantId?: string) =>
    api.get(tenantId ? `/message-templates?tenantId=${tenantId}` : '/message-templates'),
  getTemplate: (id: string) => api.get(`/message-templates/${id}`),
  updateTemplate: (id: string, data: any) =>
    api.patch(`/message-templates/${id}`, data),
  deleteTemplate: (id: string) => api.delete(`/message-templates/${id}`),

  // Batches
  createBatch: (data: any) => api.post('/message-batches', data),
  getBatches: (tenantId?: string) =>
    api.get(tenantId ? `/message-batches?tenantId=${tenantId}` : '/message-batches'),
  getBatch: (id: string) => api.get(`/message-batches/${id}`),
  updateBatch: (id: string, data: any) =>
    api.patch(`/message-batches/${id}`, data),
  loadRecipients: (id: string, data: any) =>
    api.post(`/message-batches/${id}/load-recipients`, data),
  previewRecipients: (data: any) => api.post('/message-batches/preview-recipients', data),
  deleteBatch: (id: string) => api.delete(`/message-batches/${id}`),
};
